module.exports = "/_next/static/resources/life1-de45f36f9f040a5de0aa8b920655c5e2.jpg";